import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { MuiOtpInput } from 'mui-one-time-password-input';

import './Auth.scss'

import logo_cuscapi from '../../assets/images/logo-square.png'
import merchantApi from '../../services/merchantApi'
import PhoneInputField from '../../components/PhoneInputField/PhoneInputField'

export default function AuthPage() {
  const navigate = useNavigate()
  const [phone, setPhone] = useState('')
  const [countryCode, setCountryCode] = useState('60')
  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [isOtpRequested, setIsOtpRequested] = useState(false)

  const handleLogin = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await merchantApi.auth.login({ phone: `${countryCode}${phone}`, otp_token: otp })
      navigate('/', { replace: true })
    } catch (err) {
      setError(err.message || 'Unable to login. Please check your phone number and OTP.')
    } finally {
      setLoading(false)
    }
  }

  const handleRequestOtp = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await merchantApi.auth.requestOtp({ phone: phone ? `${countryCode}${phone}` : '' })
      setIsOtpRequested(true)
    } catch (err) {
      setError(err.message || 'Unable to request OTP. Please check your phone number.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-page__card">
        <div className="auth-page__brand">
          <img src={logo_cuscapi} alt="Logo" height={48} />
        </div>

        <h1 className="auth-page__title">
          {isOtpRequested ?
            <>
              Verify your phone number
              <p>{`Enter the code sent via WhatsApp to +${countryCode} ${phone}`}</p>
              <p>Not the right number? <span onClick={() => { setIsOtpRequested(false); }}>Change number</span></p>
            </> :
            'Log in to your account'
          }
        </h1>

        <form className="auth-page__form" onSubmit={isOtpRequested ? handleLogin : handleRequestOtp}>
          {error && (
            <div className="auth-page__error">
              {error}
            </div>
          )}
          {
            !isOtpRequested && (
              <div className="auth-page__field">
                <PhoneInputField
                  value={phone}
                  onChange={(value) => setPhone(value)}
                  countryCode={countryCode}
                  onCountryCodeChange={setCountryCode}
                />
              </div>
            )
          }

          {
            isOtpRequested && (
              <div className="auth-page__field">
                <label className="auth-page__label">
                  Verification code
                </label>
                <MuiOtpInput
                  className="auth-page__mui-otp"
                  value={otp}
                  length={6}
                  gap={2}
                  onChange={(e) => setOtp(e)}
                  alignContent={'center'}
                  justifyContent={'center'}
                />
                <p className="auth-page__field-instructions">Not seeing the code? <span onClick={handleRequestOtp}>Resend</span></p>
              </div>
            )
          }

          <button className="auth-page__submit" type="submit" disabled={loading}>
            {loading ? 'Logging in...' : isOtpRequested ? 'Verify code' : 'Send verification code'}
          </button>
        </form>
      </div>
    </div>
  )
}
